import styled, { css } from 'styled-components'
import Palette from '@telus-uds/palette-allium/build/web/palette'

const VIEWPORT = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
}

export const PepPriceContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const PepPriceHeading = styled.div`
  margin-bottom: 16px;
`

export const PricesContainer = styled.div`
  flex-direction: row;
  display: flex;
`

export const LeftContainer = styled.div`
  margin-right: 36px;
  display: flex;
  flex-direction: row;
`

export const RightContainer = styled.div`
  margin-left: 36px;
  display: flex;
  flex-direction: row;
`

export const NotificationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${Palette.color.greyAlabaster};
  padding: 16px;
  margin-top: 16px;
  border-radius: 6px;
  margin-bottom: 16px;

  @media only screen and (max-width: ${VIEWPORT.xl}) {
    gap: 8px;
    flex-direction: column;
  }

  @media only screen and (min-width: ${VIEWPORT.xl}) {
    flex-direction: row;
    gap: 16px;
  }
`

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const ToggleContainer = styled.div`
  display: flex;
`

export const BottomTextContainer = styled.div`
  display: flex;

  @media only screen and (max-width: ${VIEWPORT.xl}) {
    flex-direction: column;
  }

  @media only screen and (min-width: ${VIEWPORT.xl}) {
    flex-direction: row;
    align-items: flex-end;
  }
`

export type StickyPhase = 'bottom' | 'inline' | 'top'

/**
 * Wrapper always occupies the bar's height in the document flow.
 * It acts as the scroll-position anchor and space-reserving placeholder.
 * position:relative so the StickyBar can be position:absolute inside it
 * during the 'inline' phase.
 */
export const StickyPriceBarSection = styled.div<{ height: number }>`
  position: relative;
  width: 100%;
  height: ${({ height }) => height}px;
  margin-bottom: 60px;
  pointer-events: none;
`

export const StickyPriceBarBand = styled.div<{ phase: StickyPhase }>`
  width: 100%;
  background: ${Palette.color.greyAthens};
  padding: 16px;
  box-sizing: border-box;
  z-index: 700;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  pointer-events: all;

  ${({ phase }) =>
    phase === 'bottom' &&
    css`
      position: fixed;
      bottom: 0;
      left: 0;
    `}

  ${({ phase }) =>
    phase === 'inline' &&
    css`
      position: absolute;
      top: 0;
      left: 0;
    `}

  ${({ phase }) =>
    phase === 'top' &&
    css`
      position: fixed;
      top: 0;
      left: 0;
    `}
`

export const StickyPriceBarRow = styled.div<{ priceSectionEnabled?: boolean }>`
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  @media only screen and (max-width: ${VIEWPORT.md}) {
    flex-direction: column;
    justify-content: space-around;
  }

  @media only screen and (min-width: ${VIEWPORT.md}) {
    width: 85%;
    flex-direction: row;
    justify-content: ${({ priceSectionEnabled }) => (priceSectionEnabled === false ? 'center' : 'space-between')};
  }

  @media only screen and (min-width: ${VIEWPORT.xl}) {
    width: 65%;
    justify-content: ${({ priceSectionEnabled }) => (priceSectionEnabled === false ? 'center' : 'space-between')};
  }
`

export const InfoSection = styled.div`
  display: none;
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
  }
`

export const CtaSection = styled.div`
  @media only screen and (max-width: ${VIEWPORT.md}) {
    width: 100%;
  }

  @media only screen and (min-width: ${VIEWPORT.md}) {
    min-width: 180px;
  }
`

export const StickyPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const ErrorCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
`

export const ErrorCardButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

export const TooltipContentWrapper = styled.div`
  display: inline;
  pointer-events: auto;
`
